export default "__VITE_ASSET__7jY67J88__"